import { Scene, Engine, ArcRotateCamera, Vector3, HemisphericLight, Color4 } from '@babylonjs/core';

export function createScene(engine: Engine, canvas: HTMLCanvasElement): Scene {
  const scene = new Scene(engine);

  scene.clearColor = new Color4(0.25, 0.25, 0.25, 1);

  // ArcRotateCamera framed to show both torus and ribbon (XR will replace this in AR mode)
  const sceneCenter = new Vector3(0, 1.1, 4);
  const camera = new ArcRotateCamera(
    'mainCamera',
    0, 0, 0,
    sceneCenter,
    scene
  );
  camera.setPosition(new Vector3(0, 1.1, -4));
  camera.attachControl(canvas, true);

  // Ambient lighting
  const light = new HemisphericLight('ambientLight', new Vector3(0, 1, 0), scene);
  light.intensity = 1.0;

  // Environment texture for PBR materials (no visible skybox/ground for AR)
  scene.createDefaultEnvironment({ createSkybox: false, createGround: false });

  scene.imageProcessingConfiguration.toneMappingEnabled = true;

  return scene;
}
